function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getAuthorizationsACL } from './actions';
import { getAdviserAuthorizations, getAdviserAuthorizationsGranted, getAdviserAuthorizationRequests, getAdviserAuthorizationRequestsPending, fetchRevokeAuthorization, fetchUpdateRequest, postRequest } from './thunks';
export function withAuthorizations(WrappedComponent) {
  var withAuthorizationsComponent = function (_React$Component) {
    _inherits(withAuthorizationsComponent, _React$Component);
    var _super = _createSuper(withAuthorizationsComponent);
    function withAuthorizationsComponent() {
      _classCallCheck(this, withAuthorizationsComponent);
      return _super.apply(this, arguments);
    }
    _createClass(withAuthorizationsComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props$user = this.props.user,
          _this$props$user$logg = _this$props$user.loggedIn,
          loggedIn = _this$props$user$logg === void 0 ? false : _this$props$user$logg,
          _this$props$user$isLo = _this$props$user.isLoggedIn,
          isLoggedIn = _this$props$user$isLo === void 0 ? false : _this$props$user$isLo;
        if (!(loggedIn || isLoggedIn)) {
          return;
        }
        !this.props.authorizationsProps.acl.fetched && this.props.authorizationsActions.getAuthorizationsACL();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (!prevProps.user.isLoggedIn && this.props.user.isLoggedIn) {
          this.props.authorizationsActions.getAuthorizationsACL();
        }
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(WrappedComponent, this.props);
      }
    }]);
    return withAuthorizationsComponent;
  }(React.Component);
  if (WrappedComponent.loadInitialData) {
    withAuthorizationsComponent.loadInitialData = function (store, cookie, match) {
      return Promise.all([WrappedComponent.loadInitialData(store, cookie, match), store.dispatch(getAuthorizationsACL(cookie))]);
    };
  }
  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      authorizationsActions: bindActionCreators({
        getAuthorizationsACL: getAuthorizationsACL,
        getAdviserAuthorizations: getAdviserAuthorizations,
        getAdviserAuthorizationsGranted: getAdviserAuthorizationsGranted,
        getAdviserAuthorizationRequests: getAdviserAuthorizationRequests,
        getAdviserAuthorizationRequestsPending: getAdviserAuthorizationRequestsPending,
        fetchRevokeAuthorization: fetchRevokeAuthorization,
        fetchUpdateRequest: fetchUpdateRequest,
        postRequest: postRequest
      }, dispatch)
    };
  };
  var mapStateToProps = function mapStateToProps(state) {
    return {
      user: state.user.user,
      authorizationsProps: {
        userACL: state.authorizations.acl,
        acl: state.authorizations.acl,
        obtained: {
          items: state.authorizations.obtained,
          fetching: false,
          fetched: false
        },
        requestsSent: {
          items: state.authorizations.requestsSent,
          fetching: false,
          fetched: false
        },
        granted: {
          items: state.authorizations.granted,
          fetching: false,
          fetched: false
        },
        requestsReceived: {
          items: state.authorizations.requestsReceived,
          fetching: false,
          fetched: false
        },
        requesting: state.authorizations.requesting
      }
    };
  };
  return connect(mapStateToProps, mapDispatchToProps)(withAuthorizationsComponent);
}